import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import Swal from "sweetalert2";
import { spam } from "../../services/services";
import SimpleLabel from "../micro/SimpleLabel";
import LoginModal from "./LoginModal";

class ReportModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportMsg: "",
    };
  }
  report_comment() {
    if (!localStorage.getItem(`${window.location.hostname}_token`)) {
      this.setState({ loginModal: true });
      return;
    }
    if (!this.state.reportMsg) {
      return;
    }
    let params = {
      description: this.state.reportMsg,
    };
    if (this.props.type === "comment") {
      params.comment = this.props.uId;
    }
    if (this.props.type === "product") {
      params.product = this.props.uId;
    }
    if (this.props.type === "shop") {
      params.location = this.props.uId;
    }
    spam(params).then((items) => {
      items &&
        Swal.fire({
          text: "با موفقعیت ثبت شد",
          icon: "success",
          timer: 2000,
          confirmButtonText: "تایید",
        }).then(() => {
          this.props.modalChange(!this.props.acceptReportModal);
        });
    });
  }
  render() {
    return (
      <div>
        {this.state.loginModal && (
          <LoginModal
            notReload={true}
            repeat={true}
            repeatAgain={() => this.report_comment()}
          />
        )}
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
          isOpen={this.props.acceptReportModal}
          toggle={() => this.props.modalChange(!this.props.acceptReportModal)}
        >
          <ModalBody className="row mx-0 p-4">
            <div className="col-12 px-1 mb-3">
              <p className="fw-bolder mb-3">
                گزارش
                {` ${
                  this.props.type === "comment"
                    ? "نظر"
                    : this.props.type === "product"
                    ? "محصول"
                    : this.props.type === "shop"
                    ? "فروشگاه"
                    : ""
                }`}
              </p>
              <div className="position-relative">
                <textarea
                  rows="4"
                  placeholder="توضیحات"
                  className="rounded14 p-3 form-control"
                  value={this.state.reportMsg}
                  onChange={(e) => this.setState({ reportMsg: e.target.value })}
                />
                {this.state.reportMsg && <SimpleLabel text="توضیحات" />}
              </div>
            </div>

            <div className="col-12 px-1">
              <button
                disabled={!this.state.reportMsg}
                className="btn py-2 w-100 rounded28 bg-color-main text-white fw-bold"
                onClick={() => this.report_comment()}
              >
                ثبت گزارش
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default ReportModal;
